import { isEmpty } from '@ajaibid/utils';
import { useCallback } from 'react';

function useHandleSocketMessage({ code, askOrder, setAskOrder, bidOrder, setBidOrder }) {
  const updateOrder = useCallback(
    /**
     * @param   {object}      params
     * @param   {array}       params.data
     * @param   {array}       params.order
     * @param   {function}    params.setOrder
     */
    ({ data, order, setOrder }) => {
      if (isEmpty(data)) {
        return;
      }

      const update = data.filter((item) => !!order.find(({ price }) => item.price === price));
      const insert = data.filter((item) => !order.find(({ price }) => item.price === price));

      const updated = order
        .map((item) => update.find(({ price }) => item.price === price) || item)
        .filter(({ lot }) => lot !== 0);

      const newOrder = [...updated, ...insert];

      setOrder(newOrder);
    },
    []
  );

  const updateAskOrder = useCallback(
    (askData) => {
      updateOrder({ data: askData, order: askOrder, setOrder: setAskOrder });
    },
    [askOrder, setAskOrder]
  );

  const updateBidOrder = useCallback(
    (bidData) => {
      updateOrder({ data: bidData, order: bidOrder, setOrder: setBidOrder });
    },
    [bidOrder, setBidOrder]
  );

  const handleSocketMessage = useCallback(
    (data) => {
      const { sell: askUpdate, buy: bidUpdate, ticker } = data;

      if (ticker !== code) {
        return;
      }

      updateAskOrder(askUpdate);
      updateBidOrder(bidUpdate);
    },
    [updateAskOrder, updateBidOrder]
  );

  return handleSocketMessage;
}

export default useHandleSocketMessage;
